import script from "./WorkSummaryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkSummaryForm.vue?vue&type=script&lang=ts&setup=true"

import "./WorkSummaryForm.vue?vue&type=style&index=0&id=d1e991f0&scope=true&lang=css"

const __exports__ = script;

export default __exports__